/**
 * Estilos do react-select alinhados ao theme MUI (theme_v2), para dark/light.
 * @param {import('@mui/material/styles').Theme} theme
 * @param {{ menuZIndex?: number }} [options]
 */
export function getReactSelectStyles(theme, options = {}) {
  const { palette, shape, spacing, typography, zIndex } = theme;
  const menuZ = options.menuZIndex ?? zIndex.modal;

  /** Padding similar to sibling MUI OutlinedInput (~TextField margin="dense"; default react-select uses ~2px 8px). */
  const padY = spacing(1);
  const padX = spacing(1.75);

  return {
    control: (base, state) => ({
      ...base,
      cursor: 'default',
      boxSizing: 'border-box',
      fontFamily:
        typography?.fontFamily || 'Roboto, Helvetica, Arial, sans-serif',
      fontSize: typography?.body2?.fontSize ?? 14,
      minHeight: 52,
      minWidth: 0,
      width: '100%',
      alignItems: 'center',
      backgroundColor: palette.background.paper,
      borderColor: state.isFocused ? palette.primary.main : palette.divider,
      borderRadius: shape?.borderRadius ?? 8,
      boxShadow: state.isFocused ? `0 0 0 1px ${palette.primary.main}` : 'none',
      paddingLeft: padX,
      paddingRight: spacing(0.5),
    }),
    valueContainer: (base, state) => ({
      ...base,
      paddingTop: padY,
      paddingBottom: padY,
      paddingLeft: 0,
      paddingRight: state.isMulti ? spacing(0.75) : 0,
      margin: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      alignItems: 'center',
      paddingRight: spacing(0.5),
    }),
    menu: (base) => ({
      ...base,
      marginTop: 4,
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontSize: 13,
      backgroundColor: palette.background.paper,
      zIndex: menuZ,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: menuZ,
    }),
    menuList: (base) => ({
      ...base,
      backgroundColor: palette.background.paper,
    }),
    option: (base, state) => ({
      ...base,
      cursor: 'default',
      backgroundColor: state.isSelected
        ? palette.primary.main
        : state.isFocused
          ? palette.action.hover
          : 'transparent',
      color: state.isSelected
        ? palette.primary.contrastText
        : palette.text.primary,
    }),
    singleValue: (base) => ({
      ...base,
      color: palette.text.primary,
      marginLeft: 0,
      marginRight: 0,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: palette.action.selected,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: palette.text.primary,
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: palette.text.secondary,
    }),
    input: (base) => ({
      ...base,
      color: palette.text.primary,
    }),
    placeholder: (base) => ({
      ...base,
      color: palette.text.secondary,
      margin: 0,
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: palette.divider,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: palette.text.secondary,
      paddingTop: spacing(0.75),
      paddingBottom: spacing(0.75),
      paddingLeft: spacing(0.5),
      paddingRight: spacing(0.75),
    }),
    clearIndicator: (base) => ({
      ...base,
      color: palette.text.secondary,
    }),
    container: (base) => ({
      ...base,
      marginTop: 8,
      minWidth: 0,
      width: '100%',
    }),
  };
}
